'use client';

import { useMemo } from 'react';

import type { NavBar } from '@/api/types/navigationTypes';
import { Header } from '@/components/Header/Header';
import { hardLogOut } from '@/features/auth/logout';

import { type AccountNavigationLink } from '../Header/HeaderAccountNav';

interface AuthHeaderProps {
  brandIcon?: string;
  subNavBar?: NavBar;
  isSubscribePage?: boolean;
  hasSignIn?: boolean;
  isMarketLandingPage?: boolean;
  color?: 'white' | 'secondary';
  freeTrialDays?: number;
  children?: React.ReactNode;
}

export function AuthHeader(props: AuthHeaderProps): React.ReactNode {
  const { brandIcon, subNavBar, color = 'secondary', children } = props;

  const accountNavigationLinks = useMemo((): AccountNavigationLink[] => {
    const links = [
      {
        title: 'Settings',
        href: '/settings',
      },
      {
        title: 'Log Out',
        onClick: hardLogOut,
      },
    ];

    return links;
  }, []);

  const isSearchActive = subNavBar?.subitems?.some((item) => item.item_key === 'search') ?? false;

  return (
    <Header
      brandIcon={brandIcon}
      logoLink="/home"
      isFixed
      color={color}
      isScrollTransition
      accountNavigationLinks={accountNavigationLinks}
      subNavBar={subNavBar}
      isSearchActive={isSearchActive}
    >
      {children}
    </Header>
  );
}
